/* Boncap — global theme behaviour: menu drawer, toast, scroll reveal,
   gallery thumbs, review filters, variant picker, sticky bar. Loaded on
   every page.

   THEME EDITOR SAFETY
   Shopify swaps a section's whole HTML on every setting change and fires
   `shopify:section:load` (with the new element as e.target), never
   `DOMContentLoaded` again. Anything bound only once at parse time either
   goes dead (click handlers on the old, now-discarded nodes) or, worse,
   stays invisible forever (a `.reveal` element that never gets observed
   never gets its `.in` class, so it sits at opacity:0 permanently — the
   "blank tiles" bug).

   The fix is two-fold:
   1. Interactions that are pure event handling (clicks, submits, changes)
      are bound ONCE via delegation on `document`, so a fresh node from a
      section reload is covered automatically — no re-init needed.
   2. Anything that has to look at a specific element up front (an
      IntersectionObserver target, the delivery ETA fill-in) runs through a
      small init(root) function, called for `document` on load and again
      for `event.target` on `shopify:section:load`. */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ============================================================
     Expected delivery
     ============================================================ */
  var DELIVERY = null;
  try {
    var dEl = document.getElementById('boncap-delivery');
    if (dEl) DELIVERY = JSON.parse(dEl.textContent);
  } catch (err) { console.error('[boncap] boncap-delivery is not valid JSON', err); }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function mmdd(d) {
    return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2);
  }
  /* "Thu, Sep 18" — weekday short, month short, en-US. Kept separate from
     boncapDeliveryRange() below, which the cart drawer app already calls and
     expects back as an mm/dd string; changing that return shape would break
     a consumer outside this theme. */
  var WD_FMT = { weekday: 'short', month: 'short', day: 'numeric' };
  function niceDate(d) {
    return d.toLocaleDateString('en-US', WD_FMT);
  }
  window.boncapDeliveryRange = function () {
    var D = DELIVERY;
    if (!D || !D.show) return null;
    var now = new Date(), prep = D.prep || 0;
    var a = mmdd(addBusinessDays(now, prep + (D.shipMin || 0)));
    var b = mmdd(addBusinessDays(now, prep + (D.shipMax || 0)));
    return a === b ? a : a + ' – ' + b;
  };
  /* Formatted variant used by the PDP and cart drawer copy: "Thu, Sep 18 –
     Mon, Sep 22". Same inputs as boncapDeliveryRange, just printed longhand. */
  window.boncapDeliveryRangeFormatted = function () {
    var D = DELIVERY;
    if (!D || !D.show) return null;
    var now = new Date(), prep = D.prep || 0;
    var a = addBusinessDays(now, prep + (D.shipMin || 0));
    var b = addBusinessDays(now, prep + (D.shipMax || 0));
    var na = niceDate(a), nb = niceDate(b);
    return na === nb ? na : na + ' – ' + nb;
  };

  /* Re-run whenever the section holding #boncap-eta is reloaded — the fill
     is a one-shot text write, so a fresh node from the editor starts blank
     until this runs again. */
  function initDeliveryEta(root) {
    var scope = root || document;
    var box = (scope.querySelector && scope.querySelector('#boncap-eta')) || document.getElementById('boncap-eta');
    var out = (scope.querySelector && scope.querySelector('#boncap-eta-range')) || document.getElementById('boncap-eta-range');
    var r = window.boncapDeliveryRangeFormatted();
    if (!box || !out || !r) return;
    out.textContent = r;
    box.hidden = false;
  }

  /* ============================================================
     Delegated interactions — bound once, survive any section reload
     because they never look up a specific node in advance.
     ============================================================ */

  /* ---- native product form: variant picker keeps price and button honest.
     The fallback label is read from a data attribute the section prints
     (data-label on the Add to cart button), not cached from the DOM at
     init time, so it survives a fresh render with a different variant
     already selected. ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-boncap-variant]');
    if (!sel) return;
    var form = sel.form;
    var scope = sel.closest('.buy') || document;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var now = $('[data-boncap-price-now]', scope);
    if (now && opt.dataset.price) now.textContent = opt.dataset.price;
    var btn = form ? $('[data-boncap-atc]', form) : null;
    if (btn) {
      var ok = opt.dataset.available === 'true';
      btn.disabled = !ok;
      if (!ok) btn.textContent = 'Sold out';
      else if (btn.dataset.label) btn.textContent = btn.dataset.label;
    }
  });

  /* ---- gallery full-view viewer: state lives here, not on the DOM, so a
     section reload (theme editor) can never leave it half-open. Reads
     data-full straight off the thumbs/main image already in the markup, so
     there is no separate fetch and nothing to keep in sync. ---- */
  var galViewerState = { gal: null, images: [], index: 0, trigger: null, viewer: null, home: null, nextSibling: null };
  var galTouch = { x: 0, y: 0, active: false };

  function galViewerImages(gal) {
    var out = [];
    var thumbs = $$('.gal__thumbs button', gal);
    if (thumbs.length) {
      thumbs.forEach(function (b) {
        var img = b.querySelector('img');
        out.push({ full: b.dataset.full, alt: img ? img.alt : '' });
      });
      return out;
    }
    var main = $('.gal__main-img', gal);
    if (main) out.push({ full: main.dataset.full, alt: main.alt });
    return out;
  }

  /* Builds the viewer's own thumb strip once per open, off the same image
     list as the main gallery — never a hard-coded count, so a 5- or 7-image
     product both render correctly. */
  function galViewerBuildThumbs(viewer, images) {
    var strip = $('.gal-viewer__thumbs', viewer);
    if (!strip) return;
    strip.innerHTML = '';
    if (images.length < 2) { strip.hidden = true; return; }
    strip.hidden = false;
    images.forEach(function (data, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.index = String(i);
      b.setAttribute('aria-selected', i === galViewerState.index ? 'true' : 'false');
      b.setAttribute('aria-label', 'View image ' + (i + 1));
      var img = document.createElement('img');
      img.src = data.full || '';
      img.alt = data.alt || '';
      img.draggable = false;
      b.appendChild(img);
      strip.appendChild(b);
    });
  }

  function galViewerRender() {
    var viewer = galViewerState.viewer;
    if (!viewer) return;
    var data = galViewerState.images[galViewerState.index];
    if (!data) return;
    var img = $('.gal-viewer__img', viewer);
    var counter = $('.gal-viewer__counter', viewer);
    if (img) { img.src = data.full || ''; img.alt = data.alt || ''; }
    if (counter) counter.textContent = (galViewerState.index + 1) + ' / ' + galViewerState.images.length;
    $$('.gal-viewer__thumbs button', viewer).forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.index === String(galViewerState.index) ? 'true' : 'false');
    });
  }

  /* The viewer starts life nested inside .gal so the theme editor can select
     it like any other block. The moment it opens it is re-parented to be a
     direct child of <body> — the robust fix for page content (header, sticky
     add-to-cart bar, pack picker, app blocks) painting over it, since a
     transformed/positioned ancestor anywhere in the tree can otherwise trap
     a position:fixed element inside its own containing block and stacking
     context. It moves back to its original spot on close so the editor's DOM
     stays predictable. */
  function galViewerMountToBody(viewer) {
    if (viewer.parentNode === document.body) return;
    galViewerState.home = viewer.parentNode;
    galViewerState.nextSibling = viewer.nextSibling;
    document.body.appendChild(viewer);
  }

  function galViewerRestoreHome(viewer) {
    var home = galViewerState.home;
    if (!home || viewer.parentNode !== document.body) return;
    try {
      if (galViewerState.nextSibling && galViewerState.nextSibling.parentNode === home) {
        home.insertBefore(viewer, galViewerState.nextSibling);
      } else {
        home.appendChild(viewer);
      }
    } catch (err) { /* editor may have re-rendered the section under us; leave it on body */ }
  }

  function galViewerOpen(gal, index, trigger) {
    if (!gal) return;
    var viewer = $('.gal-viewer', gal);
    if (!viewer) return;
    var images = galViewerImages(gal);
    if (!images.length) return;
    galViewerState = {
      gal: gal,
      images: images,
      index: Math.max(0, Math.min(index || 0, images.length - 1)),
      trigger: trigger || null,
      viewer: viewer,
      home: galViewerState.home,
      nextSibling: galViewerState.nextSibling
    };
    galViewerMountToBody(viewer);
    galViewerBuildThumbs(viewer, images);
    galViewerRender();
    viewer.hidden = false;
    document.documentElement.classList.add('cart-locked');
    var closeBtn = $('.gal-viewer__close', viewer);
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function galViewerClose() {
    var viewer = galViewerState.viewer;
    if (!viewer) return;
    viewer.hidden = true;
    document.documentElement.classList.remove('cart-locked');
    galViewerRestoreHome(viewer);
    var trigger = galViewerState.trigger;
    galViewerState = { gal: null, images: [], index: 0, trigger: null, viewer: null, home: null, nextSibling: null };
    if (trigger && trigger.focus) trigger.focus();
  }

  function galViewerStep(dir) {
    if (!galViewerState.gal || !galViewerState.images.length) return;
    var n = galViewerState.images.length;
    galViewerState.index = (galViewerState.index + dir + n) % n;
    galViewerRender();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* ---- gallery full-view viewer: clicks inside it never fall through to
       the thumbs/menu handlers below ---- */
    var viewerRoot = t.closest('.gal-viewer');
    if (viewerRoot) {
      if (t.closest('.gal-viewer__close')) { galViewerClose(); return; }
      if (t.closest('.gal-viewer__nav--next')) { galViewerStep(1); return; }
      if (t.closest('.gal-viewer__nav--prev')) { galViewerStep(-1); return; }
      var viewerThumb = t.closest('.gal-viewer__thumbs button');
      if (viewerThumb) {
        var jumpIndex = parseInt(viewerThumb.dataset.index, 10);
        if (!isNaN(jumpIndex)) { galViewerState.index = jumpIndex; galViewerRender(); }
        return;
      }
      /* Bar and thumb strip are chrome, not backdrop: a tap there should do
         nothing but not close the viewer either. Only the image itself and
         the empty scrim area (the stage minus the image) count as inside vs
         backdrop-to-close. */
      if (t.closest('.gal-viewer__bar') || t.closest('.gal-viewer__thumbs')) return;
      if (!t.closest('.gal-viewer__img')) { galViewerClose(); }
      return;
    }
    var expandBtn = t.closest('.gal__expand');
    if (expandBtn) {
      var galForExpand = expandBtn.closest('.gal');
      var mainForExpand = galForExpand && $('.gal__main-img', galForExpand);
      var expandIndex = mainForExpand ? parseInt(mainForExpand.dataset.index, 10) || 0 : 0;
      if (galForExpand) galViewerOpen(galForExpand, expandIndex, expandBtn);
      return;
    }
    var mainImgHit = t.closest('.gal__main-img');
    if (mainImgHit) {
      var galForMain = mainImgHit.closest('.gal');
      var mainIndex = parseInt(mainImgHit.dataset.index, 10) || 0;
      if (galForMain) galViewerOpen(galForMain, mainIndex, mainImgHit);
      return;
    }

    /* ---- gallery thumbs ---- */
    var thumbBtn = t.closest('.gal__thumbs button');
    if (thumbBtn) {
      var thumbs = thumbBtn.closest('.gal__thumbs');
      var stage = thumbBtn.closest('.gal') || document;
      var mainImg = $('#gal-main', stage) || document.getElementById('gal-main');
      $$('button', thumbs).forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
      thumbBtn.setAttribute('aria-selected', 'true');
      var img = thumbBtn.querySelector('img');
      if (!mainImg || !img) return;
      var frame = mainImg.parentElement;
      frame.classList.add('is-swapping');
      /* Badges are one overlay above the whole gallery (.gal__badges), not
         drawn per slide, so the badge state has to follow whichever slide is
         active. Each thumb/main-img carries data-hide-badges from the
         product's custom.hide_badges_on metafield (Liquid, on load); this
         just keeps .gal__main--no-badges in sync on every swap so the fade
         in boncap-pdp.css runs at the same time as the image swap. */
      frame.classList.toggle('gal__main--no-badges', thumbBtn.dataset.hideBadges === 'true');
      window.setTimeout(function () {
        mainImg.srcset = img.srcset || '';
        mainImg.src = img.src;
        mainImg.alt = img.alt;
        if (thumbBtn.dataset.full) mainImg.dataset.full = thumbBtn.dataset.full;
        if (thumbBtn.dataset.index) mainImg.dataset.index = thumbBtn.dataset.index;
        mainImg.dataset.hideBadges = thumbBtn.dataset.hideBadges || 'false';
        frame.classList.remove('is-swapping');
      }, 160);
      return;
    }

    /* ---- review filters: scope to the enclosing section so two filtered
       rows on one page never filter each other's cards ---- */
    var filterBtn = t.closest('.filters .pill');
    if (filterBtn) {
      var group = filterBtn.closest('.filters');
      var fscope = group.closest('section') || document;
      var key = filterBtn.dataset.filter;
      $$('.pill', group).forEach(function (b) { b.setAttribute('aria-pressed', b === filterBtn ? 'true' : 'false'); });
      $$('[data-tag]', fscope).forEach(function (card) {
        card.hidden = !(key === 'all' || card.dataset.tag === key);
      });
      return;
    }

    /* ---- menu drawer ---- */
    if (t.closest('#js-burger')) {
      var d = document.getElementById('js-drawer');
      setMenu(!(d && d.dataset.open === 'true'));
      return;
    }
    if (t.closest('#js-scrim') || t.closest('#js-close') || t.closest('#js-drawer a')) {
      setMenu(false);
      return;
    }
  });

  function setMenu(open) {
    var drawer = document.getElementById('js-drawer');
    var scrim = document.getElementById('js-scrim');
    var burger = document.getElementById('js-burger');
    if (!drawer) return;
    drawer.dataset.open = open ? 'true' : 'false';
    if (scrim) scrim.dataset.open = open ? 'true' : 'false';
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('keydown', function (e) {
    if (galViewerState.gal) {
      if (e.key === 'Escape') { galViewerClose(); return; }
      if (e.key === 'ArrowRight') { galViewerStep(1); return; }
      if (e.key === 'ArrowLeft') { galViewerStep(-1); return; }
      return;
    }
    if (e.key === 'Escape') setMenu(false);
  });

  /* ---- kill the blue text-selection flash on a click or double-click
     inside the gallery or the viewer. CSS user-select:none already stops
     the selection from painting on most browsers; this is the belt-and-
     suspenders fix for the ones that still flash it on mousedown. ---- */
  document.addEventListener('selectstart', function (e) {
    if (e.target && e.target.closest && (e.target.closest('.gal-viewer') || e.target.closest('.gal'))) {
      e.preventDefault();
    }
  });
  document.addEventListener('mousedown', function (e) {
    if (e.target && e.target.closest && e.target.closest('.gal-viewer__img, .gal__main-img, .gal__thumbs img, .gal-viewer__thumbs img')) {
      e.preventDefault();
    }
  });

  /* ---- gallery viewer swipe: passive touch listeners only, no
     preventDefault and no touch-action restriction on the image, so
     native iOS pinch-zoom on the full-size photo keeps working. ---- */
  document.addEventListener('touchstart', function (e) {
    if (!galViewerState.gal) return;
    if (!e.target.closest || !e.target.closest('.gal-viewer__stage')) return;
    var touch = e.touches[0];
    if (!touch) return;
    galTouch.x = touch.clientX;
    galTouch.y = touch.clientY;
    galTouch.active = true;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!galViewerState.gal || !galTouch.active) return;
    galTouch.active = false;
    var touch = e.changedTouches[0];
    if (!touch) return;
    var dx = touch.clientX - galTouch.x;
    var dy = touch.clientY - galTouch.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      galViewerStep(dx < 0 ? 1 : -1);
    }
  }, { passive: true });

  /* ---- toast, shared with the bundle builder ---- */
  var toastTimer;
  window.boncapToast = function (msg) {
    var toast = document.getElementById('js-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.dataset.open = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.dataset.open = 'false'; }, 3400);
  };

  /* ---- header condenses on scroll. The class lands on <html>, not the
     .hdr node itself, so a header re-render (new logo, menu, search toggle)
     can never leave a stale element reference behind. ---- */
  window.addEventListener('scroll', function () {
    document.documentElement.classList.toggle('is-stuck', window.scrollY > 12);
  }, { passive: true });
  document.documentElement.classList.toggle('is-stuck', window.scrollY > 12);

  /* ---- shopify:block:select — scroll a rail/grid item into view when the
     merchant selects its block in the editor sidebar ---- */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.scrollIntoView) return;
    if (el.closest('.rail') || el.closest('.vshop') || el.closest('.ugc')) {
      el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  });

  /* ============================================================
     Per-root init — anything that needs an IntersectionObserver or a
     one-shot DOM write, so it has to run again for a freshly rendered
     section. Called once for the whole document on load, then again for
     just the reloaded section on shopify:section:load.
     ============================================================ */

  /* ---- product sticky bar shows once the buy box scrolls away ---- */
  var stickyIO = null;
  function initStickyBar(root) {
    var scope = root || document;
    var bar = (scope.querySelector && scope.querySelector('#stickybar')) || document.getElementById('stickybar');
    var anchor = (scope.querySelector && scope.querySelector('#buy-anchor')) || document.getElementById('buy-anchor');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    if (stickyIO) stickyIO.disconnect();
    stickyIO = new IntersectionObserver(function (entries) {
      bar.dataset.show = entries[0].isIntersecting ? 'false' : 'true';
    }, { rootMargin: '-120px 0px 0px 0px' });
    stickyIO.observe(anchor);
  }

  /* ---- scroll reveal, with a per-child stagger.
     Content is visible by default in CSS; a group only hides once it is
     armed here (`.reveal-armed`), and the theme editor skips arming
     entirely so nothing ever flickers or gets stuck invisible while
     someone is editing. A `data-reveal-bound` flag stops the same live
     node from being armed twice if an event fires more than once for it,
     but a section reload always hands back a brand-new node, so it is
     re-armed and re-observed exactly as if the page had just loaded. */
  var revealIO = null;
  function revealGroups(scope) {
    var list = $$('.reveal', scope);
    if (scope.classList && scope.classList.contains('reveal')) list.unshift(scope);
    return list;
  }
  function initReveal(root) {
    var scope = root || document;
    var groups = revealGroups(scope).filter(function (g) { return !g.dataset.revealBound; });
    if (!groups.length) return;
    groups.forEach(function (g) { g.dataset.revealBound = '1'; });

    if (DESIGN_MODE || !('IntersectionObserver' in window)) {
      groups.forEach(function (g) { g.classList.add('in'); });
      return;
    }
    groups.forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--i', Math.min(i, 8));
      });
      group.classList.add('reveal-armed');
    });
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); revealIO.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    }
    groups.forEach(function (g) { revealIO.observe(g); });
  }

  /* ---- waitlist widget (BFCM coming-soon PDP mode).
     Remembers a signup in localStorage (never a cookie, no server round
     trip needed) so a returning visitor sees the done state immediately
     instead of the form again. The done-state swap on a fresh signup comes
     from boncap-klaviyo.js's boncap:klaviyo:subscribed event, delegated
     here so it works the first time and after any section reload. */
  function showWaitlistDone(box) {
    var step1 = box.querySelector('[data-waitlist-step1]');
    var step2 = box.querySelector('[data-waitlist-step2]');
    var check = box.querySelector('[data-waitlist-check]');
    var done = box.querySelector('[data-waitlist-done]');
    if (step1) step1.hidden = true;
    if (step2) step2.hidden = true;
    if (check) check.hidden = true;
    if (done) done.hidden = false;
  }
  /* Optimistic: hide step one and show the check the instant Klaviyo
     accepts the phone call, then swap in step two a beat later so the
     shopper sees the confirmation rather than a hard cut. No network wait
     for the swap itself — it is a timer, not a second request. */
  function showWaitlistStep2(box, phone) {
    var step1 = box.querySelector('[data-waitlist-step1]');
    var step2 = box.querySelector('[data-waitlist-step2]');
    if (step1) step1.hidden = true;
    if (step2) {
      step2.hidden = false;
      var captured = step2.querySelector('[data-captured-phone]');
      if (captured && phone) captured.value = phone;
      var emailInput = step2.querySelector('input[type="email"]');
      if (emailInput) emailInput.focus();
    }
  }
  function initWaitlist(root) {
    var scope = root || document;
    $$('[data-waitlist]', scope).forEach(function (box) {
      var key = box.dataset.waitlistKey;
      if (!key) return;
      var signed = false;
      try { signed = window.localStorage.getItem('boncap_waitlist_' + key) === '1'; } catch (err) { /* private mode etc */ }
      if (signed) showWaitlistDone(box);
    });
  }
  document.addEventListener('boncap:klaviyo:phone-done', function (e) {
    var box = e.target.closest && e.target.closest('[data-waitlist]');
    if (!box) return;
    var phone = e.detail && e.detail.phone;
    var check = box.querySelector('[data-waitlist-check]');
    if (check) {
      check.hidden = false;
      window.setTimeout(function () {
        check.hidden = true;
        showWaitlistStep2(box, phone);
      }, 700);
    } else {
      showWaitlistStep2(box, phone);
    }
  });
  document.addEventListener('click', function (e) {
    var skip = e.target.closest && e.target.closest('[data-waitlist-skip]');
    if (!skip) return;
    var box = skip.closest('[data-waitlist]');
    if (box) showWaitlistStep2(box, null);
  });
  document.addEventListener('boncap:klaviyo:subscribed', function (e) {
    var box = e.target.closest && e.target.closest('[data-waitlist]');
    if (!box) return;
    var key = box.dataset.waitlistKey;
    if (key) {
      try { window.localStorage.setItem('boncap_waitlist_' + key, '1'); } catch (err) { /* private mode etc */ }
    }
    showWaitlistDone(box);
  });

  function initSection(root) {
    initReveal(root);
    initStickyBar(root);
    initDeliveryEta(root);
    initWaitlist(root);
  }

  function boot() { initSection(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
})();
